import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined'
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined'
import SceneAccessGateShell from './SceneAccessGateShell'
import { resolveAnySceneAccessCode } from '../../actions/sceneGuestAccess.actions'

const normalizeCode = (value) => String(value || '').trim()

const SceneGuestEntryPage = ({ setShowFooter }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [accessKey, setAccessKey] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        setShowFooter?.(false)

        return () => {
            setShowFooter?.(true)
        }
    }, [setShowFooter])

    const submit = async (event) => {
        event.preventDefault()

        const clean = normalizeCode(accessKey)

        if (!clean || loading) return

        setLoading(true)
        setError('')

        const result = await dispatch(resolveAnySceneAccessCode(clean))

        setLoading(false)

        if (!result?.ok) {
            setError(result?.error || 'Код доступа не найден')
            return
        }

        const redirectPath = String(result.data?.redirectPath || '').trim()

        if (!redirectPath) {
            setError('Сервер не вернул адрес доступа')
            return
        }

        navigate(redirectPath)
    }

    return (
        <SceneAccessGateShell
            icon={<KeyOutlinedIcon />}
            kicker="Единый 3D-доступ"
            title="Открыть сцену или совместную сессию"
            description="Введите код, полученный от менеджера. Система сама определит, открываете вы готовую сцену или подключаетесь к совместной работе."
            error={error}
            note="При переходе по прямой ссылке код вводить не нужно. PIN появится отдельно, только когда менеджер включил защиту."
            className="sceneGuestEntry"
        >
            <form className="sceneGuestEntry__form sceneAccessGateway__form" onSubmit={submit}>
                <label>
                    <span>Код доступа</span>
                    <input
                        value={accessKey}
                        onChange={(event) => {
                            setAccessKey(event.target.value)
                            if (error) setError('')
                        }}
                        placeholder="SCN-ABCD-2345 или SES-ABCD-2345"
                        autoComplete="one-time-code"
                        autoCapitalize="characters"
                        spellCheck={false}
                        autoFocus
                    />
                </label>

                <button type="submit" disabled={loading || !normalizeCode(accessKey)}>
                    {loading ? 'Проверяем…' : 'Продолжить'}
                    <ArrowForwardOutlinedIcon />
                </button>
            </form>
        </SceneAccessGateShell>
    )
}

export default SceneGuestEntryPage
